import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { OutputSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { NOC_MODE_FILTERS, DEFAULT_SORT, METRIC_CATEGORY } from '@utils/constants';
import { isAppSPIEnabledSelector } from '@store/common/selectors';
import {
  nocModeSelector,
  trendsViewSelector,
  filtersViewSelector,
} from '@store/noc/base/selectors';
import { setFiltersSorting, setTrendsSorting } from '@store/noc/base/actions';
import { MetricSelectorPopup } from '@components/common';
import { filtersProps, trendsProps } from './utils';
interface MDProps {
  metricSelector: OutputSelector<any, any[], (res1: {}, res2: any) => any[]>;
  setMetrics: (metrics: string[]) => any;
}

// wrapper to switch between filters and trends context
const Wrapper = () => {
  const mode = useSelector(nocModeSelector);
  const dropdownProps = mode === NOC_MODE_FILTERS ? filtersProps : trendsProps;

  return <MetricDropdown {...dropdownProps} />;
};

function MetricDropdown({ metricSelector, setMetrics }: MDProps) {
  const dispatch = useDispatch();

  const mode = useSelector(nocModeSelector);
  const trends = useSelector(trendsViewSelector);
  const filters = useSelector(filtersViewSelector);
  const isAppSPIEnabled = useSelector(isAppSPIEnabledSelector);

  const onMetricSelectHandler = (metrics) => {
    mode === NOC_MODE_FILTERS ? setFilterSort(metrics) : setTrendsSort(metrics);
    dispatch(setMetrics(metrics));
  };

  const setTrendsSort = (metrics) => {
    if (!metrics.includes(trends.sort.key)) {
      dispatch(setTrendsSorting(DEFAULT_SORT));
    }
  };

  const setFilterSort = (metrics) => {
    if (!metrics.includes(filters.sort.key)) {
      dispatch(setFiltersSorting(DEFAULT_SORT));
    }
  };

  let excludeCategories: any = [];
  if (!isAppSPIEnabled) {
    excludeCategories = [METRIC_CATEGORY.eco.QOE_AND_KPI_METRICS];
  }

  const { selectedMetrics, metricOptions }: any = useSelector(metricSelector);

  if (isEmpty(metricOptions)) {
    return null;
  }

  return (
    <MetricSelectorPopup
      supportedMetrics={metricOptions}
      selectedMetrics={selectedMetrics}
      onApply={onMetricSelectHandler}
      excludeCategories={excludeCategories}
    />
  );
}

export default Wrapper;
